export { TorchesView } from './TorchesView'
export type { TorchesViewProps } from './TorchesView'
